import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MenuItems from "./MenuItems";
import RSMobileMenu from "./RSMobileMenu";
import TopHeader from "./TopBar";
import liteLogo from "../../../assets/img/logo/lite-logo.png";
import darkLogo from "../../../assets/img/logo/dark-logo.png";
import normalLogo from "../../../assets/img/logo/logo.png";

const Header = (props) => {
  const [searchText, setSearchText] = useState("");
  const {
    headerClass,
    parentMenu,
    secondParentMenu,
    activeMenu,
    mobileNormalLogo,
    TopBar,
    TopBarClass,
    emailAddress,
    phoneNumber,
    Location,
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Sticky is displayed after scrolling for 100 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);


  return (
    <React.Fragment>
      <div
        className={
          headerClass
            ? headerClass
            : "full-width-header home8-style4 main-home "
        }
      >
        <header id="rs-header" className="rs-header">
          {TopBar ? (
            <TopHeader
              topBarClass={TopBarClass}
              emailAddress={emailAddress}
              phoneNumber={phoneNumber}
              Location={Location}
            />
          ) : (
            ""
          )}

          <div className={"menu-area menu-sticky"}>
            <div className="container">
              <div className="row y-middle">
                <div className="col-lg-2">
                  {/* Desktop logo: visible from lg and up */}
                  <div className="logo-area d-none d-lg-block">
                    <Link to="/">
                      <img
                        className="normal-logo"
                        src={
                          window.location.pathname == "/"
                            ? normalLogo
                            : darkLogo
                        }
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-8 text-end">
                  <div className="rs-menu-area">
                    <div className="main-menu">
                      {/* Mobile header row: visible below lg */}
                      <div className="mobile-menu d-flex d-lg-none align-items-center justify-content-between w-100 flex-nowrap">
                        {/* Mobile logo (lite) */}
                        <Link to="/" className="mobile-normal-logo d-inline-flex align-items-center">
                          <img className="normal-logo" src={liteLogo} alt="Syrol" />
                        </Link>
                        {/* Right-side actions: button and toggle in one line */}
                        <div className="d-inline-flex align-items-center ms-auto">
                          <a
                            href="tel:+2348064160204"
                            className="rs-menu-toggle readon green-banner header-btn p-2 d-inline-flex align-items-center"
                            style={{ fontSize: "0.85rem", lineHeight: 1, height: 60 }}
                            aria-label="Call Syrol Technologies at (+234) 904 320 5555"
                          >
                            <i className="fa fa-phone mr-2" aria-hidden="true"></i>
                            Call
                          </a>
                          <Link
                            to="#"
                            className="rs-menu-toggle readon green-banner menu-toggle-btn p-2 d-inline-flex align-items-center justify-content-center"
                            style={{ height: 60 }}
                            onClick={() => {
                              setMenuOpen(!menuOpen);
                            }}
                            aria-label="Toggle menu"
                          >
                            <i className="fa fa-bars"></i>
                          </Link>
                        </div>
                      </div>
                      <nav className="rs-menu hidden-md">
                        <ul className="nav-menu">
                          <MenuItems
                            parentMenu={parentMenu}
                            secondParentMenu={secondParentMenu}
                            activeMenu={activeMenu}
                          />
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 relative text-end d-none d-lg-block">
                  <div className="expand-btn-inner search-icon">
                    {/* <ul className="expand-items">
                      <li className="sidebarmenu-search">
                        <input
                          type="search"
                          className="rs-search search-input"
                          placeholder="Search course..."
                          onChange={(e) => {
                            setSearchText(e.target.value);
                          }}
                          onSubmit={() => {
                            if (searchText != "" && searchText.length > 2) {
                              window.location.href = `/courses?search=${searchText}`;
                            }
                          }}
                          onKeyUp={(e) => {
                            if (searchText != "" && searchText.length > 2) {
                              if (e.key === "Enter") {
                                window.location.href = `/courses?search=${searchText}`;
                              }
                            }
                          }}
                        />
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <RSMobileMenu
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            parentMenu={parentMenu}
            secondParentMenu={secondParentMenu}
          />
          <div
            onClick={() => setMenuOpen(false)}
            className={menuOpen ? "body-overlay show" : "body-overlay"}
          ></div>
        </header>
        {/* <CanvasMenu
					canvasClass={CanvasClass ? CanvasClass : "right_menu_togle orange_color hidden-md"}
					canvasLogo={CanvasLogo ? CanvasLogo : darkLogo}
				/> */}
      </div>
    </React.Fragment>
  );
};

export default Header;
